import type { FilmCharacter } from "@/mocks/films";

export default function CharacterSection({ characters }: { characters: FilmCharacter[] }) {
  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-7">
      <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
        <i className="ri-group-line text-xl text-primary-600" />
        角色分析
      </h2>
      <p className="mt-2 text-sm text-foreground-600">梳理主要角色的性格动机与人物关系，理解故事背后的选择。</p>

      <ul className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2">
        {characters.map((character) => (
          <li key={character.name} className="flex gap-4 rounded-lg bg-background-100 p-4">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-accent-500 font-heading text-lg font-bold text-background-50">
              {character.name.slice(0, 1)}
            </span>
            <div className="flex-1">
              <div className="flex flex-wrap items-baseline gap-x-2">
                <h3 className="font-heading text-base font-semibold text-foreground-950">{character.name}</h3>
                <span className="text-xs text-foreground-500">饰 · {character.actor}</span>
              </div>
              <p className="mt-0.5 text-xs font-medium text-primary-700">{character.role}</p>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{character.description}</p>
              <div className="mt-3 flex flex-wrap gap-1.5">
                {character.traits.map((trait) => (
                  <span key={trait} className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-800">
                    {trait}
                  </span>
                ))}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}